export type { ThemeDefinition } from './types';
export { deriveDarkVariant } from './derive-dark';
export { koodooka, koodookaLight } from './koodooka';
export { koodookaDark } from './koodooka-dark';
export { bankingClassic } from './banking-classic';
export { modernMinimal } from './modern-minimal';
export { highContrast } from './high-contrast';
export { oceanic } from './oceanic';

import { bankingClassic } from './banking-classic';
import { modernMinimal } from './modern-minimal';
import { highContrast } from './high-contrast';
import { oceanic } from './oceanic';
import { deriveDarkVariant } from './derive-dark';
import { koodookaLight } from './koodooka';
import { koodookaDark } from './koodooka-dark';

/** All light theme definitions */
export const lightThemes = [koodookaLight, bankingClassic, modernMinimal, highContrast, oceanic] as const;

/** All themes; Koodooka has an explicit dark definition while legacy themes retain derived variants. */
export const allThemes = [
  koodookaLight,
  koodookaDark,
  bankingClassic,
  deriveDarkVariant(bankingClassic),
  modernMinimal,
  deriveDarkVariant(modernMinimal),
  highContrast,
  deriveDarkVariant(highContrast),
  oceanic,
  deriveDarkVariant(oceanic),
];
